import { Modal } from 'antd'

import { PunchoutSessionDataFragment } from '~/gql/graphql'
import { openChatDrift } from '~/redux-modules/drift'

import { BaseWebStorage } from './BaseWebStorage'

/**
 * Service to work with value in session storage which represents a user's punchout session details
 */
class PunchoutSessionStorage extends BaseWebStorage<PunchoutSessionDataFragment | null> {
    protected key = 'PUNCHOUT_SESSION_DETAILS'
    protected modalOpened = false

    getItem(): PunchoutSessionDataFragment | null {
        const data = this.storage.getItem(this.key)

        if (!data) {
            return null
        }

        const sessionData = JSON.parse(data)
        const currentTime = new Date().getTime()
        const expireTime = new Date(sessionData.expireAt).getTime()

        if (currentTime >= expireTime) {
            this.removeItem()
            if (!this.modalOpened) {
                Modal.error({
                    title: 'Your Punchout ordering session has timed out',
                    content:
                        'Your ordering session via an external procurment system has expired due to inactivity. To continue purchasing parts, re-select Fictiv as the supplier from your procurement portal.',
                    okText: 'Return to page',
                    cancelText: 'Contact us',
                    onCancel: openChatDrift,
                    okCancel: true,
                    width: '520px',
                })
                this.modalOpened = true
            }
            return null
        } else {
            return sessionData
        }
    }

    setItem(sessionData: PunchoutSessionDataFragment | null) {
        return this.storage.setItem(this.key, JSON.stringify(sessionData))
    }

    removeItem() {
        return this.storage.removeItem(this.key)
    }
}

export const punchoutSessionStorage = new PunchoutSessionStorage(
    'sessionStorage',
)
